var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"7","height":"4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M.666.833l.707-.708L3.667 2.46 5.959.125l.707.708-2.999 3.042L.666.833z","fill":"#4C4541"}})])}
var staticRenderFns = []

export { render, staticRenderFns }